import React, { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress, Typography, Paper, Stack } from "@mui/material";
import {
    MenuBook as HandbookIcon,
    Construction as ComingSoonIcon,
    OpenInNew as OpenIcon,
} from "@mui/icons-material";
import CompanyInfoService from "../services/CompanyInfo.service";

export default function Handbook() {
    const [handbook, setHandbook] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        CompanyInfoService.get()
            .then((res) => {
                if (res.data.employee_handbook_url) {
                    setHandbook({
                        url: res.data.employee_handbook_url,
                        updated: res.data.employee_handbook_updated,
                    });
                }
            })
            .catch(() => setError("Failed to load the handbook."))
            .finally(() => setLoading(false));
    }, []);

    return (
        <Box>
            {/* Header */}
            <Paper
                elevation={0}
                sx={{
                    border: "1px solid",
                    borderColor: "primary.main",
                    borderRadius: 1,
                    p: 2.5,
                    mb: 2,
                }}
            >
                <Stack direction="row" alignItems="center" spacing={1.5}>
                    <HandbookIcon sx={{ fontSize: 36, color: "secondary.main" }} />
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography
                            variant="h5"
                            fontWeight={700}
                            sx={{ fontFamily: "Montserrat, sans-serif" }}
                        >
                            Company Handbook
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {handbook?.updated
                                ? `Last updated ${new Date(handbook.updated).toLocaleDateString()}`
                                : "Policies, procedures, and employee guidelines."}
                        </Typography>
                    </Box>
                    {handbook && (
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<OpenIcon />}
                            href={handbook.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Open
                        </Button>
                    )}
                </Stack>
            </Paper>

            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : handbook ? (
                // Mobile browsers often can't render a PDF inside an iframe,
                // so the Open button above stays as the fallback.
                <Paper
                    elevation={0}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                        overflow: "hidden",
                        height: { xs: "70vh", md: "calc(100vh - 220px)" },
                    }}
                >
                    <Box
                        component="iframe"
                        src={handbook.url}
                        title="Company Handbook"
                        sx={{ width: "100%", height: "100%", border: 0 }}
                    />
                </Paper>
            ) : (
                <Paper
                    elevation={0}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                        p: 6,
                        textAlign: "center",
                    }}
                >
                    <ComingSoonIcon sx={{ fontSize: 48, color: "text.disabled", mb: 1 }} />
                    <Typography variant="h6" fontWeight={700} sx={{ fontFamily: "Montserrat, sans-serif", mb: 0.5 }}>
                        Coming Soon
                    </Typography>
                    <Typography color="text.secondary">
                        The company handbook is being put together and will be available here soon.
                    </Typography>
                </Paper>
            )}
        </Box>
    );
}
